import { StrictMode } from "react";
import MainCalendar from "./calendar";
import { defaultInput, InputDataWithDefaults } from "./calendar/model";
import CalendarProvider from "./calendar/context/CalendarProvider";
import InputStateProvider from "./calendar/inputState/InputStateProvider";
import { InputState } from "./calendar/inputState";
import { Provider } from "react-redux";
import store from "./store/store";
import "./i18n";

const App = ({
    inputData,
    inputState,
}: {
    inputData: InputDataWithDefaults;
    inputState: InputState;
}) => (
    <StrictMode>
        <Provider store={store}>
            <InputStateProvider inputState={inputState}>
                <CalendarProvider inputData={{ ...defaultInput, ...inputData }}>
                    <MainCalendar />
                </CalendarProvider>
            </InputStateProvider>
        </Provider>
    </StrictMode>
);

export default App;
